import { ItemView, locale, util } from '@glu/core';

import template from './paginationControls.hbs';

export default ItemView.extend({
  template,

  ui: {
    $pageSelect: '.paginate-page-select',
    $lastPageButton: '.last-page',
    $nextPageButton: '.next-page',
    $prevPageButton: '.prev-page',
    $firstPageButton: '.first-page'
  },

  events: {
    'change @ui.$pageSelect': 'handlePageSelect'
  },

  handlePageSelect(e) {
    const vals = this.$(e.currentTarget).flexDropdown('val');
    this.options.pager.handlePageSelect(vals[0]);
  },

  onBeforeClose() {
    this.ui.$pageSelect.flexDropdown('destroy');
  },

  templateHelpers() {
    return util.extend(this.options.data, {
      cid: this.cid
    });
  },

  onRender() {
    this.toggleActionButtons();
    this.initDropDown();
  },

  initDropDown() {
    const { pager } = this.options;

    this.ui.$pageSelect.flexDropdown({
      label: locale.get('page'), // missing 'sr-only' piece: 'number'
      showTooltip: false,
      disableMultiButton: true,
      preSelectedIds: [this.options.data.currentPageNumber],
      data: util.map(this.options.data.pages, (page) => ({
        id: page,
        name: page
      })),
      dataQA: `${pager.options.id}-curr-page`
    });
  },

  toggleActionButtons() {
    // 0/number = zero in case if size of inputCollection equal to zero
    const totalPages = this.options.pager.getPageCount();

    const lastPage = this.options.pager.getCurrentPage() === totalPages;
    const firstPage = this.options.pager.getCurrentPage() === 1;

    if (lastPage) {
      this.ui.$lastPageButton.attr('disabled', true);
      this.ui.$nextPageButton.attr('disabled', true);
    } else {
      this.ui.$lastPageButton.removeAttr('disabled');
      this.ui.$nextPageButton.removeAttr('disabled');
    }

    if (firstPage) {
      this.ui.$firstPageButton.attr('disabled', true);
      this.ui.$prevPageButton.attr('disabled', true);
    } else {
      this.ui.$firstPageButton.removeAttr('disabled');
      this.ui.$prevPageButton.removeAttr('disabled');
    }
  }
});
